/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface EvidenceWithPaymentsWarnings
 */
export interface EvidenceWithPaymentsWarnings {
    /**
     * 
     * @type {string}
     * @memberof EvidenceWithPaymentsWarnings
     */
    'detectedDpi'?: EvidenceWithPaymentsWarningsDetectedDpiEnum;
    /**
     * 
     * @type {string}
     * @memberof EvidenceWithPaymentsWarnings
     */
    'calculatedDpi'?: EvidenceWithPaymentsWarningsCalculatedDpiEnum;
    /**
     * 
     * @type {string}
     * @memberof EvidenceWithPaymentsWarnings
     */
    'colorGradation'?: EvidenceWithPaymentsWarningsColorGradationEnum;
    /**
     * 
     * @type {string}
     * @memberof EvidenceWithPaymentsWarnings
     */
    'heightMillis'?: EvidenceWithPaymentsWarningsHeightMillisEnum;
    /**
     * 
     * @type {string}
     * @memberof EvidenceWithPaymentsWarnings
     */
    'widthMillis'?: EvidenceWithPaymentsWarningsWidthMillisEnum;
}

export const EvidenceWithPaymentsWarningsDetectedDpiEnum = {
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type EvidenceWithPaymentsWarningsDetectedDpiEnum = typeof EvidenceWithPaymentsWarningsDetectedDpiEnum[keyof typeof EvidenceWithPaymentsWarningsDetectedDpiEnum];
export const EvidenceWithPaymentsWarningsCalculatedDpiEnum = {
    pixelsInsufficient: 'PIXELS_INSUFFICIENT',
    pixelsRequired: 'PIXELS_REQUIRED',
    realSizeRequired: 'REAL_SIZE_REQUIRED',
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type EvidenceWithPaymentsWarningsCalculatedDpiEnum = typeof EvidenceWithPaymentsWarningsCalculatedDpiEnum[keyof typeof EvidenceWithPaymentsWarningsCalculatedDpiEnum];
export const EvidenceWithPaymentsWarningsColorGradationEnum = {
    required: 'REQUIRED',
    insufficient: 'INSUFFICIENT'
} as const;

export type EvidenceWithPaymentsWarningsColorGradationEnum = typeof EvidenceWithPaymentsWarningsColorGradationEnum[keyof typeof EvidenceWithPaymentsWarningsColorGradationEnum];
export const EvidenceWithPaymentsWarningsHeightMillisEnum = {
    required: 'REQUIRED'
} as const;

export type EvidenceWithPaymentsWarningsHeightMillisEnum = typeof EvidenceWithPaymentsWarningsHeightMillisEnum[keyof typeof EvidenceWithPaymentsWarningsHeightMillisEnum];
export const EvidenceWithPaymentsWarningsWidthMillisEnum = {
    required: 'REQUIRED'
} as const;

export type EvidenceWithPaymentsWarningsWidthMillisEnum = typeof EvidenceWithPaymentsWarningsWidthMillisEnum[keyof typeof EvidenceWithPaymentsWarningsWidthMillisEnum];


